import LeadsIndex from '../laisLeads/pages/LeadsIndex.vue';
import { laisPath } from '../laisRouteHelpers';

const clientsCrmRoute = {
  path: laisPath('crm-clientes'),
  component: LeadsIndex,
};

export default clientsCrmRoute;
